import {FC, useEffect, useRef, useState} from "react";
import {Container, MainContent} from "../styles";
import SidebarCardHeader from "../../SidebarCardHeader";
import {SearchInputCustom} from "../../../ui/SearchInputCustom";
import {ResultSearchContentSidebarCard} from "../../Sidebar/styles";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar/SidebarSearch";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {dataMapDirectionFilters} from "../dataMapFilters";
import {SidebarCardSearchDirectionItem} from "./SidebarCardSearchDirectionItem";

interface IProps {
  onCloseCard: () => void;
  typeRadar: ITypeRadar;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  searchDatasidebarInfo?: IDataForSearchSidebar;
}

export const SidebarCardSearch: FC<IProps> = ({
  onCloseCard,
  typeRadar,
  openSidebarWithTab,
  searchDatasidebarInfo,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [resultSearchFind, setResultSearchFind] = useState(
    {} as IDataForSearchSidebar
  );
  const [sortOption, setSortOption] = useState<string>("");
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);
  const handleSort = (option: string) => {
    console.log(option);
  };

  const handleTypeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
  };

  useEffect(() => {
    const resultsFindDirections =
      inputSearchValue === ""
        ? searchDatasidebarInfo?.directions
        : searchDatasidebarInfo?.directions?.filter((item) =>
            item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
          );
    setResultSearchFind((prev) => ({
      ...prev,
      directions: resultsFindDirections ?? [],
    }));
  }, [inputSearchValue, searchDatasidebarInfo]);

  const handleSortTitle = () => {
    return `КЛАСТЕРЫ `;
  };

  console.log("resultSearchFind", searchDatasidebarInfo);
  return (
    <Container>
      <SidebarCardHeader
        previewTitle="Направления"
        title="ПОИСК ПО НАПРАВЛЕНИЯМ"
        colorTitle="#53C6F5"
        onClose={onCloseCard}
        color="#858E97"
      />
      <MainContent>
        <SearchInputCustom
          searchInputRef={searchInputRef}
          inputSearchValue={inputSearchValue}
          handleTypeSearch={handleTypeSearch}
          setInputSearchValue={setInputSearchValue}
        />

        {/* {inputSearchValue.length > 0 && ( */}
        <div
          style={{
            color: "#fff",
            padding: "5px 0",
            zIndex: 1,
          }}
        >
          {resultSearchFind.directions &&
          resultSearchFind.directions.length > 0 ? (
            <div>
              <BlockFIlteredMap
                handleSortTitle={handleSortTitle}
                handleSort={handleSort}
                sortOption={sortOption}
                dataMapFiltered={dataMapDirectionFilters}
                setIsShowTitleParams={setIsShowTitleParams}
                isShowTitleParams={isShowTitleParams}
                isHideSortBlock={true}
              />
              {/* <p
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "16px",
                  margin: "20px 0 10px",
                }}
              >
                Результаты:
              </p> */}
              {typeRadar === "map" && (
                <ResultSearchContentSidebarCard>
                  <div>
                    {resultSearchFind.directions.map((item) => {
                      return (
                        <SidebarCardSearchDirectionItem
                          key={item.id}
                          id={item.id}
                          name={item.name}
                          searchDatasidebarInfo={searchDatasidebarInfo}
                          isShowTitleParams={isShowTitleParams}
                          typeRadar={typeRadar}
                          openSidebarWithTab={openSidebarWithTab}
                        />
                      );
                    })}
                  </div>
                </ResultSearchContentSidebarCard>
              )}
            </div>
          ) : (
            <div
              style={{
                padding: "5px 10px",
                borderBottom: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              Ничего не найдено
            </div>
          )}
        </div>
        {/* )} */}
      </MainContent>
    </Container>
  );
};
